import CardMedia from '@mui/material/CardMedia';
export default CardMedia;
